import { DriverPlanNotAcceptableResponseErrorType } from "../../../../api/raily/driver/plan/accept/driver-plan-accept.response";
import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../../utils/data-load-error/data-load-error";

export enum DriverPlanAcceptErrorType {
  NO_TAXI_DRIVER_ASSOCIATION = "NO_TAXI_DRIVER_ASSOCIATION",
  NO_VALID_TAXI_DRIVER_CONTRACT = "NO_VALID_TAXI_DRIVER_CONTRACT",
  NO_VALID_TAXI_RAILY_CONTRACT = "NO_VALID_TAXI_RAILY_CONTRACT",
  NO_VALID_CARGO_RAILY_CONTRACT = "NO_VALID_CARGO_RAILY_CONTRACT",
  TARGET_PLAN_ENTRY_NOT_FOUND = "TARGET_PLAN_ENTRY_NOT_FOUND",
  CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME = "CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME",
  CANDIDATE_DOES_NOT_FIT = "CANDIDATE_DOES_NOT_FIT",
  TOO_MANY_CHECKOUT_EVENTS = "TOO_MANY_CHECKOUT_EVENTS",
  CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION = "CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION",
  DELETE_SOLVED_ORDER_TARGET_NOT_FOUND = "DELETE_SOLVED_ORDER_TARGET_NOT_FOUND",
  PLAN_ENTRY_CANDIDATE_COLLISION = "PLAN_ENTRY_CANDIDATE_COLLISION",
  PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR = "PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR",
  FORBIDDEN_TAXI = "FORBIDDEN_TAXI",
  FORBIDDEN_PLAN_ENTRY = "FORBIDDEN_PLAN_ENTRY",
  DEFAULT_ERROR = "DEFAULT_ERROR",
}

export type DriverPlanAcceptCandidateDoesNotFitError = DataLoadError<
  DriverPlanAcceptErrorType.CANDIDATE_DOES_NOT_FIT,
  {}
>;

export type DriverPlanAcceptCandidateFitsWithNotEnoughTimeError = DataLoadError<
  DriverPlanAcceptErrorType.CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME,
  {}
>;

export type DriverPlanAcceptCandidateFitsWithPlanEntryCollisionError =
  DataLoadError<
    DriverPlanAcceptErrorType.CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION,
    {}
  >;

export type DriverPlanAcceptDeleteSolvedOrderTargetNotFoundError =
  DataLoadError<
    DriverPlanAcceptErrorType.DELETE_SOLVED_ORDER_TARGET_NOT_FOUND,
    {}
  >;

export type DriverPlanAcceptForbiddenPlanEntryError = DataLoadError<
  DriverPlanAcceptErrorType.FORBIDDEN_PLAN_ENTRY,
  {}
>;

export type DriverPlanAcceptForbiddenTaxiError = DataLoadError<
  DriverPlanAcceptErrorType.FORBIDDEN_TAXI,
  {}
>;

export type DriverPlanAcceptNoTaxiDriverAssociationError = DataLoadError<
  DriverPlanAcceptErrorType.NO_TAXI_DRIVER_ASSOCIATION,
  {}
>;

export type DriverPlanAcceptNoValidCargoRailyContractError = DataLoadError<
  DriverPlanAcceptErrorType.NO_VALID_CARGO_RAILY_CONTRACT,
  {}
>;

export type DriverPlanAcceptNoValidTaxiDriverContractError = DataLoadError<
  DriverPlanAcceptErrorType.NO_VALID_TAXI_DRIVER_CONTRACT,
  {}
>;

export type DriverPlanAcceptNoValidTaxiRailyContractError = DataLoadError<
  DriverPlanAcceptErrorType.NO_VALID_TAXI_RAILY_CONTRACT,
  {}
>;

export type DriverPlanAcceptPlanENtryCandidateCollisionError = DataLoadError<
  DriverPlanAcceptErrorType.PLAN_ENTRY_CANDIDATE_COLLISION,
  {}
>;

export type DriverPlanAcceptPlanEntryCandidateStartTimeExpiredErrorError =
  DataLoadError<
    DriverPlanAcceptErrorType.PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR,
    {}
  >;

export type DriverPlanAcceptTargetPlanEntryNotFoundError = DataLoadError<
  DriverPlanAcceptErrorType.TARGET_PLAN_ENTRY_NOT_FOUND,
  {}
>;

export type DriverPlanAcceptTooManyCheckoutEventsError = DataLoadError<
  DriverPlanAcceptErrorType.TOO_MANY_CHECKOUT_EVENTS,
  {}
>;

export type DriverPlanAcceptDefaultError = DataLoadError<
  DriverPlanAcceptErrorType.DEFAULT_ERROR,
  {
    responseErrorType: DriverPlanNotAcceptableResponseErrorType;
  }
>;

type DriverPlanAcceptError =
  | DataLoadDefaultErrors
  | DriverPlanAcceptCandidateDoesNotFitError
  | DriverPlanAcceptCandidateFitsWithNotEnoughTimeError
  | DriverPlanAcceptCandidateFitsWithPlanEntryCollisionError
  | DriverPlanAcceptDeleteSolvedOrderTargetNotFoundError
  | DriverPlanAcceptForbiddenPlanEntryError
  | DriverPlanAcceptForbiddenTaxiError
  | DriverPlanAcceptNoTaxiDriverAssociationError
  | DriverPlanAcceptNoValidCargoRailyContractError
  | DriverPlanAcceptNoValidTaxiDriverContractError
  | DriverPlanAcceptNoValidTaxiRailyContractError
  | DriverPlanAcceptPlanENtryCandidateCollisionError
  | DriverPlanAcceptPlanEntryCandidateStartTimeExpiredErrorError
  | DriverPlanAcceptDefaultError
  | DriverPlanAcceptTargetPlanEntryNotFoundError
  | DriverPlanAcceptTooManyCheckoutEventsError;

export default DriverPlanAcceptError;
